"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyMultipleSelect = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyCheckBox_1 = __importDefault(require("../SskyCheckBox"));

const StyledMenuItem = (0, material_1.styled)(material_1.MenuItem)({
  borderBottom: "1px solid #ddd"
});
const StyledFormControl = (0, material_1.styled)(material_1.FormControl, {
  shouldForwardProp: prop => prop !== "minWidth" && prop !== "width"
})(({
  theme,
  minWidth,
  width
}) => ({
  margin: theme.spacing(1),
  minWidth: minWidth || 120,
  width: width
}));
const StyledInputLabel = (0, material_1.styled)(material_1.InputLabel)({
  [`&.${material_1.inputLabelClasses.root}`]: {
    fontSize: 16
  }
});

const SskyMultipleSelect = props => {
  const renderItems = () => {
    let menuItems = props.items.map(item => {
      return react_1.default.createElement(material_1.MenuItem, {
        key: item.key,
        value: item.value,
        "data-testid": item.dataTestId || `testId-${item.key}`
      }, react_1.default.createElement(SskyCheckBox_1.default, {
        checked: props.value.indexOf(item.value) > -1
      }), react_1.default.createElement(material_1.ListItemText, {
        primary: item.text
      }));
    });

    if (props.selectAll) {
      let checked = props.items.length === props.value.length;
      let intermediate = props.value.length !== props.items.length && props.value.length > 0;
      menuItems.unshift(react_1.default.createElement(StyledMenuItem, {
        key: "ssky_all",
        value: "~ssky_all~"
      }, react_1.default.createElement(SskyCheckBox_1.default, {
        checked: checked,
        indeterminate: intermediate
      }), react_1.default.createElement(material_1.ListItemText, {
        primary: props.selectAllText
      })));
    }

    return menuItems;
  };

  const onChange = (e, item) => {
    let value = e.target.value;

    if (props.selectAll) {
      if (value.includes("~ssky_all~")) {
        if (value.length === props.items.length + 1) {
          e.target.value = [];
        } else {
          e.target.value = props.items.map(item => item.value);
        }
      }
    }

    props.onChange(e, item);
  };

  return react_1.default.createElement(StyledFormControl, {
    id: props.id,
    className: props.className,
    error: props.error,
    disabled: props.disabled,
    width: props.width,
    minWidth: props.minWidth
  }, props.label && react_1.default.createElement(StyledInputLabel, null, props.label), react_1.default.createElement(material_1.Select, {
    value: props.value,
    onChange: onChange,
    onClose: props.onClose,
    onOpen: props.onOpen,
    multiple: true,
    renderValue: props.renderValue,
    "data-testid": props.dataTestId || `testId-${props.id || props.label}`
  }, renderItems()), react_1.default.createElement(material_1.FormHelperText, null, props.helperText));
};

exports.SskyMultipleSelect = SskyMultipleSelect;
SskyMultipleSelect.defaultProps = {
  value: [],
  renderValue: selected => selected.join(', '),
  selectAllText: "All"
};
exports.default = react_1.default.memo(SskyMultipleSelect);